import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/milocare/banner-back.webp";

function Banner() {
  return (
    <section
      className="banner_milo banner_parcheesi text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/milocare/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={309}
                height={152}
              />
            </div>
            <h1>Revolutionizing Health Record Management with MiloCare+</h1>
            <p>
              MiloCare+, created by TekRevol, transforms health record
              management. This case study discovers the project's purposes,
              challenges, solutions, and the deep influence it has had on users'
              access to dynamic health data.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/milo-care/id1614461225">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.onemilo&pli=1">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/milocare/banner-mob.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={590}
                height={587}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
